<div class="card highlight-card card-small">
    <h2>{{ title || 'Sin title' | uppercase }}</h2>
</div>